"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const dialog_1 = require("@angular/material/dialog");
const residents_service_1 = require("../services/residents.service");
const resident_model_1 = require("../resident.model");
const dnaRSnackBar_service_1 = require("../../common/dna-r/dnaRSnackBar.service");
require("../../organisation/dtos/facility-dto");
const facility_service_1 = require("../../organisation/services/facility.service");
const rxjs_1 = require("rxjs");
require("../../organisation/dtos/AccommodationTypeDto");
const assign_bed_filter_1 = require("./assign-bed-filter");
const assign_bed_filter_dto_1 = require("../dtos/assign-bed-filter-dto");
const i0 = require("@angular/core");
const i1 = require("../services/residents.service");
const i2 = require("@angular/forms");
const i3 = require("@angular/material/dialog");
const i4 = require("../../common/dna-r/dnaRSnackBar.service");
const i5 = require("../../organisation/services/facility.service");
const i6 = require("@angular/material/tooltip");
const i7 = require("@angular/material/icon");
const i8 = require("@angular/common");
const i9 = require("../../common/components/dnaR-dropdown-multiSelect/dnaR-dropdown-multiSelect.component");
const i10 = require("../../common/components/dnaR-datePicker/dnaR-datePicker.component");
const i11 = require("./loading-assign-bed.component");
const i12 = require("../resident-profile-photo/resident-profile-photo.component");
function AssignBedModalComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelementStart(1, "i", 38);
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " Effective date ");
    i0.ɵɵelementStart(4, "div", 39);
    i0.ɵɵelementStart(5, "dnaR-date-picker", 40);
    i0.ɵɵlistener("ngModelChange", function AssignBedModalComponent_div_11_Template_dnaR_date_picker_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.effectiveDate = $event; })("onComponentChange", function AssignBedModalComponent_div_11_Template_dnaR_date_picker_onComponentChange_5_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.onEffectiveDateValueChanged($event, ctx_r14.effectiveDate); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("min", ctx_r0.minDate)("max", ctx_r0.maxDate)("ngModel", ctx_r0.effectiveDate);
} }
function AssignBedModalComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 41);
} }
function AssignBedModalComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 42);
} }
function AssignBedModalComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵtext(2, " Location ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵelementStart(4, "dnaR-dropdown-multiSelect", 43);
    i0.ɵɵlistener("initialSelectedItemsChange", function AssignBedModalComponent_div_14_Template_dnaR_dropdown_multiSelect_initialSelectedItemsChange_4_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.filter.facilityLocations = $event; });
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("placeholder", "Filter by location")("settings", ctx_r3.filterDropdownSettings)("data", i0.ɵɵpipeBind1(5, 5, ctx_r3.LocationsList$))("initialSelectedItems", ctx_r3.filter.facilityLocations)("disabled", !ctx_r3.effectiveDate && ctx_r3.requestedAdmissionDate === undefined);
} }
function AssignBedModalComponent_div_25_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵlistener("click", function AssignBedModalComponent_div_25_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.swapOccupiedBedChanged(); });
    i0.ɵɵelement(1, "input", 49);
    i0.ɵɵelement(2, "div", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("checked", ctx_r17.isSwapChecked);
} }
function AssignBedModalComponent_div_25_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelement(1, "input", 52);
    i0.ɵɵelement(2, "div");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("checked", ctx_r18.isSwapChecked);
} }
function AssignBedModalComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵtemplate(1, AssignBedModalComponent_div_25_div_1_Template, 3, 1, "div", 45);
    i0.ɵɵtemplate(2, AssignBedModalComponent_div_25_div_2_Template, 3, 1, "div", 46);
    i0.ɵɵelementStart(3, "div", 47);
    i0.ɵɵtext(4, " Swap with occupied bed ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.effectiveDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.effectiveDate);
} }
function AssignBedModalComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Location");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AssignBedModalComponent_div_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Roommate/s");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AssignBedModalComponent_div_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Resident");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AssignBedModalComponent_loading_assign_bed_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-assign-bed", 55);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("facilityHasLocations", ctx_r8.facilityHasLocations);
} }
function AssignBedModalComponent_div_43_div_1_div_1_button_1_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 69);
    i0.ɵɵpipe(1, "date");
} if (rf & 2) {
    const formGroup_r23 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("matTooltip", "Bed will be out of service from ", i0.ɵɵpipeBind2(1, 2, formGroup_r23.get("nextOutOfServiceStartDate").value, "dd-MMM-yyyy"), "");
    i0.ɵɵproperty("matTooltipPosition", "after");
} }
function AssignBedModalComponent_div_43_div_1_div_1_button_1_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 70);
    i0.ɵɵpipe(1, "date");
} if (rf & 2) {
    const formGroup_r23 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("matTooltip", "Bed change occurred ", i0.ɵɵpipeBind2(1, 2, formGroup_r23.get("nextOccupiedStartDate").value, "dd-MMM-yyyy"), "");
    i0.ɵɵproperty("matTooltipPosition", "after");
} }
function AssignBedModalComponent_div_43_div_1_div_1_button_1_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 70);
    i0.ɵɵpipe(1, "date");
} if (rf & 2) {
    const formGroup_r23 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("matTooltip", "Bed change occurred ", i0.ɵɵpipeBind2(1, 2, formGroup_r23.get("occupiedEndDate").value, "dd-MMM-yyyy"), "");
    i0.ɵɵproperty("matTooltipPosition", "after");
} }
function AssignBedModalComponent_div_43_div_1_div_1_button_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r23 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(formGroup_r23.get("location").value);
} }
function AssignBedModalComponent_div_43_div_1_div_1_button_1_div_13_div_1_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const roommate_r37 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", roommate_r37.preferredName, ")");
} }
const _c0 = function (a0) { return { "not-selectable": a0 }; };
function AssignBedModalComponent_div_43_div_1_div_1_button_1_div_13_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 72);
    i0.ɵɵelementStart(2, "span", 73);
    i0.ɵɵelement(3, "resident-profile-photo", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 75);
    i0.ɵɵtext(5);
    i0.ɵɵtemplate(6, AssignBedModalComponent_div_43_div_1_div_1_button_1_div_13_div_1_span_6_Template, 2, 1, "span", 67);
    i0.ɵɵelementStart(7, "p", 76);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const roommate_r37 = ctx.$implicit;
    const formGroup_r23 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("residentId", roommate_r37.residentId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, formGroup_r23.get("nextOccupiedStartDate").value !== null));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", roommate_r37.firstName, " ", roommate_r37.lastName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", roommate_r37.preferredName !== "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" Bed ", roommate_r37.bedNumber, " ");
} }
function AssignBedModalComponent_div_43_div_1_div_1_button_1_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AssignBedModalComponent_div_43_div_1_div_1_button_1_div_13_div_1_Template, 9, 8, "div", 71);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r23 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", formGroup_r23.get("roommates").value);
} }
function AssignBedModalComponent_div_43_div_1_div_1_button_1_div_14_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r23 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", formGroup_r23.get("residentPreferredName").value, ")");
} }
function AssignBedModalComponent_div_43_div_1_div_1_button_1_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 72);
    i0.ɵɵelementStart(1, "span", 73);
    i0.ɵɵelement(2, "resident-profile-photo", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 75);
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, AssignBedModalComponent_div_43_div_1_div_1_button_1_div_14_span_5_Template, 2, 1, "span", 67);
    i0.ɵɵelementStart(6, "p", 76);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r23 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("residentId", formGroup_r23.get("residentId").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, formGroup_r23.get("nextOccupiedStartDate").value !== null));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", formGroup_r23.get("residentFirstName").value, " ", formGroup_r23.get("residentLastName").value, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formGroup_r23.get("residentPreferredName").value !== "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" Bed ", formGroup_r23.get("bedNumber").value, " ");
} }
const _c1 = function (a0, a1) { return { "not-selectable": a0, "selected": a1 }; };
const _c2 = function (a0) { return { "roommates-no-locations": a0 }; };
function AssignBedModalComponent_div_43_div_1_div_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 62);
    i0.ɵɵlistener("click", function AssignBedModalComponent_div_43_div_1_div_1_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r47); const i_r24 = i0.ɵɵnextContext().index; const ctx_r45 = i0.ɵɵnextContext(3); return ctx_r45.bedSelected(i_r24); });
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 26);
    i0.ɵɵelementStart(4, "span", 63);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, AssignBedModalComponent_div_43_div_1_div_1_button_1_span_6_Template, 2, 5, "span", 64);
    i0.ɵɵtemplate(7, AssignBedModalComponent_div_43_div_1_div_1_button_1_span_7_Template, 2, 5, "span", 65);
    i0.ɵɵtemplate(8, AssignBedModalComponent_div_43_div_1_div_1_button_1_span_8_Template, 2, 5, "span", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, AssignBedModalComponent_div_43_div_1_div_1_button_1_div_9_Template, 2, 1, "div", 27);
    i0.ɵɵelementStart(10, "div", 28);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 66);
    i0.ɵɵtemplate(13, AssignBedModalComponent_div_43_div_1_div_1_button_1_div_13_Template, 2, 1, "div", 67);
    i0.ɵɵtemplate(14, AssignBedModalComponent_div_43_div_1_div_1_button_1_div_14_Template, 8, 8, "div", 68);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r23 = i0.ɵɵnextContext().$implicit;
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c1, formGroup_r23.get("nextOccupiedStartDate").value !== null || formGroup_r23.get("occupiedEndDate").value !== null, formGroup_r23.get("isSelected").value))("disabled", formGroup_r23.get("nextOccupiedStartDate").value !== null);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(formGroup_r23.get("roomNumber").value);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c0, formGroup_r23.get("nextOccupiedStartDate").value !== null));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(formGroup_r23.get("bedNumber").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formGroup_r23.get("nextOccupiedStartDate").value === null && formGroup_r23.get("nextOutOfServiceStartDate").value !== null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formGroup_r23.get("nextOccupiedStartDate").value !== null && formGroup_r23.get("occupiedEndDate").value === null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formGroup_r23.get("occupiedEndDate").value !== null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r25.facilityHasLocations);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(formGroup_r23.get("accommodationType").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c2, !ctx_r25.facilityHasLocations));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r25.isSwapChecked);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r25.isSwapChecked);
} }
function AssignBedModalComponent_div_43_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵtemplate(1, AssignBedModalComponent_div_43_div_1_div_1_button_1_Template, 15, 20, "button", 61);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r23 = ctx.$implicit;
    const i_r24 = ctx.index;
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroup", formGroup_r23);
    i0.ɵɵattribute("data-index", i_r24);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r22.isLoading);
} }
function AssignBedModalComponent_div_43_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 58);
    i0.ɵɵtemplate(1, AssignBedModalComponent_div_43_div_1_div_1_Template, 2, 3, "div", 59);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r21.formAssignBeds.controls)("ngForTrackBy", ctx_r21.trackByFn);
} }
function AssignBedModalComponent_div_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtemplate(1, AssignBedModalComponent_div_43_div_1_Template, 2, 2, "div", 57);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.formAssignBeds.controls.length > 0);
} }
function AssignBedModalComponent_div_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 77);
    i0.ɵɵelement(1, "div", 78);
    i0.ɵɵelementStart(2, "div", 79);
    i0.ɵɵtext(3, "Enter effective date to view beds");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AssignBedModalComponent_div_45_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 81);
    i0.ɵɵtext(1, "Try removing some filters.");
    i0.ɵɵelementEnd();
} }
function AssignBedModalComponent_div_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 77);
    i0.ɵɵelement(1, "div", 78);
    i0.ɵɵelementStart(2, "div", 79);
    i0.ɵɵtext(3, "No results");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, AssignBedModalComponent_div_45_div_4_Template, 2, 0, "div", 80);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r11.filter.roomTypes.length > 0 || ctx_r11.filter.facilityLocations.length > 0);
} }
class AssignBedModalComponent {
    constructor(residentsService, formBuilder, dialog, snackBarService, facilityService) {
        this.residentsService = residentsService;
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.snackBarService = snackBarService;
        this.facilityService = facilityService;
        this.submitted = false;
        this.assignBedForm = this.formBuilder.group({
            formAssignBeds: this.formBuilder.array([])
        });
        this.isLoading = false;
        this.isSwapChecked = false;
        this.facilityHasLocations = false;
        this.isAvailableBedsInfo = false;
        /**
         * Settings for the filter dropdowns.
         */
        this.filterDropdownSettings = {
            singleSelection: false,
            idField: "id",
            headerField: 'header',
            textField: "name",
            itemsShowLimit: 1,
            maxHeight: 162,
            addAllOption: false,
            enableCheckAll: false
        };
        this.LocationsList$ = new rxjs_1.BehaviorSubject(null);
        this.roomTypesList$ = new rxjs_1.BehaviorSubject(null);
        this.filter = new assign_bed_filter_1.AssignBedFilter();
    }
    /**
     * @inheritDoc
     */
    ngOnInit() {
        this.getSelectedFacility();
        this.getUnitTypesForSelectedFacility();
    }
    getSelectedFacility() {
        this.facilityService.getFacilityLocations().then(result => {
            this.facilityLocations = result;
            this.facilityHasLocations = this.facilityLocations.length > 0;
            this.loadSelectedFacilityLocations();
        }, () => {
            this.snackBarService.failure("Unexpected error while loading facility");
        });
    }
    getUnitTypesForSelectedFacility() {
        this.facilityService.getUnitTypesForSelectedFacility().then((result) => {
            this.loadSelectedRoomTypes(result);
        });
    }
    ngOnChanges() {
        if (this.requestedAdmissionDate !== undefined) {
            this.residentsService.getAvailableBedsAndRooms(null, this.residentId, this.requestedAdmissionDate, this.expectedDepartureDate).then(result => {
                result.forEach((availableRoomInfo, index) => {
                    this.isAvailableBedsInfo = true;
                    this.addNewFormGroup(index, availableRoomInfo);
                });
            });
        }
        else {
            this.maxDate = new Date();
            this.minDate = new Date(this.bedEffectiveDate);
        }
    }
    loadSelectedFacilityLocations() {
        const facilityLocations = [...this.facilityLocations];
        facilityLocations.push({
            id: -1,
            name: "No location",
            accommodations: null,
        });
        facilityLocations.sort((a, b) => a.name.localeCompare(b.name));
        this.LocationsList$.next(facilityLocations);
    }
    loadSelectedRoomTypes(accommodationTypes) {
        accommodationTypes.sort((a, b) => a.name.localeCompare(b.name));
        this.roomTypesList$.next(accommodationTypes);
    }
    get formAssignBeds() {
        return this.assignBedForm.controls["formAssignBeds"];
    }
    submit() {
        this.submitted = true;
        (setTimeout(_ => {
            // to assure form recalculate it's status
            this.assignBedForm.updateValueAndValidity();
            if (this.assignBedForm.status === 'VALID') {
                this.submitForm();
            }
        }));
    }
    cancel() {
        this.hideDialogEvent();
    }
    disableSaveButton() {
        var disabled = !this.assignBedForm.touched || (this.submitted && this.assignBedForm.status !== 'VALID');
        return disabled;
    }
    submitForm() {
        let roomChange = new resident_model_1.RoomChange();
        roomChange.isBedSwap = this.isSwapChecked;
        roomChange.effectiveDate = this.currentEffectiveDate;
        roomChange.selectedBedId = this.selectedBedId;
        roomChange.bedNumber = this.selectedBedNumber;
        roomChange.roomNumber = this.selectedRoomNumber;
        roomChange.location = this.selectedRoomLocation;
        roomChange.accommodationType = this.selectedRoomAccommodationType;
        this.saveEventCallBack(roomChange);
        this.hideDialogEvent();
    }
    onEffectiveDateValueChanged($event, newEffectiveDate) {
        //Clear the form so that we don't endup with old data if the user selects a new date
        //when another date was previously selected:
        this.formAssignBeds.clear();
        newEffectiveDate = new Date(Date.UTC(newEffectiveDate.getFullYear(), newEffectiveDate.getMonth(), newEffectiveDate.getDate(), 0, 0, 0, 0));
        if ($event.value !== null &&
            newEffectiveDate !== undefined &&
            ((this.currentEffectiveDate === undefined) || newEffectiveDate.getTime() !== this.currentEffectiveDate.getTime())) {
            this.currentEffectiveDate = newEffectiveDate;
            this.loadBeds(this.residentId, this.currentEffectiveDate, this.expectedDepartureDate);
        }
    }
    addNewFormGroup(atIndex, roomUseInfo) {
        if ((this.isSwapChecked && !this.isAvailableBedsInfo) || (!this.isSwapChecked && this.isAvailableBedsInfo)) {
            const formGroup = this.formBuilder.group({
                bedId: [roomUseInfo.bedId],
                bedNumber: [roomUseInfo.bedNumber],
                roomNumber: [roomUseInfo.roomNumber],
                accommodationType: [roomUseInfo.accommodationType],
                location: [(roomUseInfo.location != undefined) ? roomUseInfo.location : ''],
                nextOutOfServiceStartDate: [roomUseInfo.nextOutOfServiceStartDate],
                nextOccupiedStartDate: [roomUseInfo.nextOccupiedStartDate],
                isSelected: [(roomUseInfo.isSelected)],
                roommates: [(roomUseInfo.roommates)],
                residentFirstName: [(roomUseInfo.residentFirstName)],
                residentLastName: [(roomUseInfo.residentLastName)],
                residentPreferredName: [(roomUseInfo.residentPreferredName)],
                residentId: [(roomUseInfo.residentId)],
                occupiedEndDate: [(roomUseInfo.occupiedEndDate)]
            });
            this.formAssignBeds.insert(atIndex, formGroup);
        }
    }
    bedSelected(atIndex) {
        let previouslySelectedBed = this.formAssignBeds.controls.find(x => x.get('isSelected').value);
        if (previouslySelectedBed) {
            previouslySelectedBed.get('isSelected').setValue(false);
        }
        this.formAssignBeds.controls[atIndex].get('isSelected').setValue(true);
        this.selectedBedId = this.formAssignBeds.controls[atIndex].get('bedId').value;
        this.formAssignBeds.markAsTouched();
        this.selectedBedNumber = this.formAssignBeds.controls[atIndex].get('bedNumber').value;
        this.selectedRoomNumber = this.formAssignBeds.controls[atIndex].get('roomNumber').value;
        this.selectedRoomLocation = this.formAssignBeds.controls[atIndex].get('location').value;
        this.selectedRoomAccommodationType = this.formAssignBeds.controls[atIndex].get('accommodationType').value;
    }
    swapOccupiedBedChanged() {
        //Need to clear old data so we don't endup with outdated data from previous swap checkbox selection:
        this.formAssignBeds.clear();
        this.isSwapChecked = !this.isSwapChecked;
        this.loadBeds(this.residentId, this.currentEffectiveDate, this.expectedDepartureDate);
    }
    loadBeds(residentId, currentEffectiveDate, expectedDepartureDate) {
        this.isLoading = true;
        //Need to clear old data so we don't endup with outdated data:
        this.formAssignBeds.clear();
        const assignBedFilter = new assign_bed_filter_dto_1.AssignBedFilterDto();
        if (this.filter.facilityLocations !== undefined) {
            assignBedFilter.facilityLocations = this.filter.facilityLocations.join(",");
        }
        if (this.filter.roomTypes !== undefined) {
            assignBedFilter.roomTypes = this.filter.roomTypes.join(",");
        }
        if (this.isSwapChecked) {
            this.residentsService.getOccupiedBedsAndRooms(assignBedFilter, residentId, currentEffectiveDate, expectedDepartureDate).then(result => {
                result.forEach((occupiedRoomInfo, index) => {
                    this.isAvailableBedsInfo = false;
                    this.addNewFormGroup(index, occupiedRoomInfo);
                });
                this.isLoading = false;
            });
        }
        else {
            this.residentsService.getAvailableBedsAndRooms(assignBedFilter, residentId, currentEffectiveDate, expectedDepartureDate).then(result => {
                result.forEach((availableRoomInfo, index) => {
                    this.isAvailableBedsInfo = true;
                    this.addNewFormGroup(index, availableRoomInfo);
                });
                this.isLoading = false;
            });
        }
    }
    applyFilters() {
        this.formAssignBeds.clear();
        this.formAssignBeds.markAsUntouched();
        let effectiveDate = this.requestedAdmissionDate !== undefined ? this.requestedAdmissionDate : this.currentEffectiveDate;
        this.loadBeds(this.residentId, effectiveDate, this.expectedDepartureDate);
    }
    trackByFn(index, item) {
        return item.id;
    }
}
exports.AssignBedModalComponent = AssignBedModalComponent;
AssignBedModalComponent.ɵfac = function AssignBedModalComponent_Factory(t) { return new (t || AssignBedModalComponent)(i0.ɵɵdirectiveInject(i1.ResidentsService), i0.ɵɵdirectiveInject(i2.FormBuilder), i0.ɵɵdirectiveInject(i3.MatDialog), i0.ɵɵdirectiveInject(i4.DnaRSnackBarService), i0.ɵɵdirectiveInject(i5.FacilityService)); };
AssignBedModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AssignBedModalComponent, selectors: [["assign-bed-modal"]], inputs: { hideDialogEvent: "hideDialogEvent", saveEventCallBack: "saveEventCallBack", bedEffectiveDate: "bedEffectiveDate", requestedAdmissionDate: "requestedAdmissionDate", residentId: "residentId", expectedDepartureDate: "expectedDepartureDate", filter: "filter", minDate: "minDate", maxDate: "maxDate" }, features: [i0.ɵɵNgOnChangesFeature], decls: 52, vars: 22, consts: [[1, "modal-dialog", "angular-dialog"], [1, "body"], ["mat-dialog-title", "", 1, "modal-header", "modal-header-action"], [1, "col-xs-11", "noSidePadding"], [1, "modal-title", "title"], [1, "col-xs-1", "noSidePadding"], ["mat-icon-button", "", "matTooltip", "Cancel", "matTooltipClass", "mat-tooltip", "aria-label", "close dialog", "mat-dialog-close", "", 1, "close-modal", "pull-right", 3, "click"], [1, "icon", "icon-close-fill", "close-modal-icon"], [1, "modal-body"], [1, "left-panel"], ["class", "col-xs-12 effective-date-header", 4, "ngIf"], ["class", "left-panel-no-effective-date-top", 4, "ngIf"], ["class", "left-panel-separator", 4, "ngIf"], ["class", "filter-search-container", 4, "ngIf"], [1, "filter-search-container"], [1, "filter-label"], [1, "dropdown"], ["name", "roomTypes", "data-automation", "roomTypes", 3, "placeholder", "settings", "data", "initialSelectedItems", "disabled", "initialSelectedItemsChange"], [1, "apply-filters"], ["type", "button", 1, "btn", "btn-secondary", "btn-md", "apply-filters-btn", 3, "disabled", "click"], ["class", "swap-container", 4, "ngIf"], [1, "beds-section"], [3, "formGroup"], [1, "col-xs-12", "noSidePadding", "bed-list"], [1, "col-xs-12", "noSidePadding", "list-header"], [1, "column", "room-column"], [1, "column", "bed-column"], ["class", "column location-column", 4, "ngIf"], [1, "column", "room-type-column"], ["class", "column roommate-column", 4, "ngIf"], [3, "facilityHasLocations", 4, "ngIf"], ["class", "col-xs-12 noSidePadding", "formArrayName", "formAssignBeds", 4, "ngIf"], ["class", "no-effective-date", 4, "ngIf"], [1, "modal-footer", "col-xs-12"], [1, "btn-group-md", "dna-r"], ["type", "button", 1, "btn", "btn-warning", "modal-warning-button", 3, "click"], ["type", "submit", 1, "btn", "btn-primary", "modal-action-button", 3, "disabled", "click"], [1, "col-xs-12", "effective-date-header"], [1, "required", "asterisk"], [1, "effective-date-picker"], ["name", "effectiveDate", "ngDefaultControl", "", 3, "min", "max", "ngModel", "ngModelChange", "onComponentChange"], [1, "left-panel-no-effective-date-top"], [1, "left-panel-separator"], ["name", "locations", "data-automation", "locations", 3, "placeholder", "settings", "data", "initialSelectedItems", "disabled", "initialSelectedItemsChange"], [1, "swap-container"], ["class", "swap swap-hover", 3, "click", 4, "ngIf"], ["class", "swap", 4, "ngIf"], [1, "swap-text"], [1, "swap", "swap-hover", 3, "click"], ["name", "swap", "type", "checkbox", 3, "checked"], [1, "checkbox"], [1, "swap"], ["name", "swap", "type", "checkbox", "disabled", "", 1, "disable-swap-checkbox", 3, "checked"], [1, "column", "location-column"], [1, "column", "roommate-column"], [3, "facilityHasLocations"], ["formArrayName", "formAssignBeds", 1, "col-xs-12", "noSidePadding"], ["class", "beds-data", 4, "ngIf"], [1, "beds-data"], ["class", "group-data", 3, "formGroup", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "group-data", 3, "formGroup"], ["class", "accommodation-row", 3, "ngClass", "disabled", "click", 4, "ngIf"], [1, "accommodation-row", 3, "ngClass", "disabled", "click"], [1, "bed-number", 3, "ngClass"], ["class", "alert-warning warning-icon out-of-service", "matTooltipClass", "mat-tooltip", 3, "matTooltip", "matTooltipPosition", 4, "ngIf"], ["class", "alert-warning warning-icon occupied", "matTooltipClass", "mat-tooltip", 3, "matTooltip", "matTooltipPosition", 4, "ngIf"], [1, "column", "roommate-column", 3, "ngClass"], [4, "ngIf"], ["class", "roommate-info", 4, "ngIf"], ["matTooltipClass", "mat-tooltip", 1, "alert-warning", "warning-icon", "out-of-service", 3, "matTooltip", "matTooltipPosition"], ["matTooltipClass", "mat-tooltip", 1, "alert-warning", "warning-icon", "occupied", 3, "matTooltip", "matTooltipPosition"], [4, "ngFor", "ngForOf"], [1, "roommate-info"], [1, "photo-wrapper"], [3, "residentId"], [1, "roommate-name-and-bed", 3, "ngClass"], [1, "bed"], [1, "no-effective-date"], [1, "empty-icon"], [1, "no-results-text"], ["class", "sub-text", 4, "ngIf"], [1, "sub-text"]], template: function AssignBedModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "h3", 4);
        i0.ɵɵtext(5, "Assign bed");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "button", 6);
        i0.ɵɵlistener("click", function AssignBedModalComponent_Template_button_click_7_listener() { return ctx.cancel(); });
        i0.ɵɵelement(8, "mat-icon", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵtemplate(11, AssignBedModalComponent_div_11_Template, 6, 3, "div", 10);
        i0.ɵɵtemplate(12, AssignBedModalComponent_div_12_Template, 1, 0, "div", 11);
        i0.ɵɵtemplate(13, AssignBedModalComponent_div_13_Template, 1, 0, "div", 12);
        i0.ɵɵtemplate(14, AssignBedModalComponent_div_14_Template, 6, 7, "div", 13);
        i0.ɵɵelementStart(15, "div", 14);
        i0.ɵɵelementStart(16, "div", 15);
        i0.ɵɵtext(17, " Room type ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 16);
        i0.ɵɵelementStart(19, "dnaR-dropdown-multiSelect", 17);
        i0.ɵɵlistener("initialSelectedItemsChange", function AssignBedModalComponent_Template_dnaR_dropdown_multiSelect_initialSelectedItemsChange_19_listener($event) { return ctx.filter.roomTypes = $event; });
        i0.ɵɵpipe(20, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 14);
        i0.ɵɵelementStart(22, "div", 18);
        i0.ɵɵelementStart(23, "button", 19);
        i0.ɵɵlistener("click", function AssignBedModalComponent_Template_button_click_23_listener() { return ctx.applyFilters(); });
        i0.ɵɵtext(24, " Apply filters ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(25, AssignBedModalComponent_div_25_Template, 5, 2, "div", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 21);
        i0.ɵɵelementStart(27, "form", 22);
        i0.ɵɵelementStart(28, "div", 23);
        i0.ɵɵelementStart(29, "div", 24);
        i0.ɵɵelementStart(30, "div", 25);
        i0.ɵɵelementStart(31, "span");
        i0.ɵɵtext(32, "Room");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 26);
        i0.ɵɵelementStart(34, "span");
        i0.ɵɵtext(35, "Bed");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(36, AssignBedModalComponent_div_36_Template, 3, 0, "div", 27);
        i0.ɵɵelementStart(37, "div", 28);
        i0.ɵɵelementStart(38, "span");
        i0.ɵɵtext(39, "Room type");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(40, AssignBedModalComponent_div_40_Template, 3, 0, "div", 29);
        i0.ɵɵtemplate(41, AssignBedModalComponent_div_41_Template, 3, 0, "div", 29);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(42, AssignBedModalComponent_loading_assign_bed_42_Template, 1, 1, "loading-assign-bed", 30);
        i0.ɵɵtemplate(43, AssignBedModalComponent_div_43_Template, 2, 1, "div", 31);
        i0.ɵɵtemplate(44, AssignBedModalComponent_div_44_Template, 4, 0, "div", 32);
        i0.ɵɵtemplate(45, AssignBedModalComponent_div_45_Template, 5, 1, "div", 32);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "div", 33);
        i0.ɵɵelementStart(47, "div", 34);
        i0.ɵɵelementStart(48, "button", 35);
        i0.ɵɵlistener("click", function AssignBedModalComponent_Template_button_click_48_listener() { return ctx.cancel(); });
        i0.ɵɵtext(49, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "button", 36);
        i0.ɵɵlistener("click", function AssignBedModalComponent_Template_button_click_50_listener() { return ctx.submit(); });
        i0.ɵɵtext(51, "Assign bed");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("ngIf", ctx.requestedAdmissionDate === undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.requestedAdmissionDate !== undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.requestedAdmissionDate === undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.facilityHasLocations);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("placeholder", "Filter by room type")("settings", ctx.filterDropdownSettings)("data", i0.ɵɵpipeBind1(20, 20, ctx.roomTypesList$))("initialSelectedItems", ctx.filter.roomTypes)("disabled", !ctx.effectiveDate && ctx.requestedAdmissionDate === undefined);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", !ctx.effectiveDate && ctx.requestedAdmissionDate === undefined);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.requestedAdmissionDate === undefined);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.assignBedForm);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.facilityHasLocations);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", !ctx.isSwapChecked);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSwapChecked);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isLoading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.effectiveDate !== undefined || ctx.requestedAdmissionDate !== undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.requestedAdmissionDate === undefined && ctx.effectiveDate === undefined && !ctx.isLoading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.requestedAdmissionDate !== undefined || ctx.effectiveDate !== undefined) && !ctx.isLoading && ctx.formAssignBeds.controls.length === 0);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("disabled", ctx.disableSaveButton());
    } }, directives: [i6.MatTooltip, i7.MatIcon, i8.NgIf, i9.DnaRDropdownMultiSelect, i2.ɵangular_packages_forms_forms_y, i2.NgControlStatusGroup, i2.FormGroupDirective, i10.DnaRDatePicker, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, i11.LoadingAssignBedComponent, i2.FormArrayName, i8.NgForOf, i8.NgClass, i12.ResidentProfilePhotoComponent], pipes: [i8.AsyncPipe, i8.DatePipe], styles: [".modal-dialog[_ngcontent-%COMP%] {\n  width: 1394px;\n}\n.left-panel[_ngcontent-%COMP%] {\n  width: 312px !important;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  float: left;\n  padding-left: 15px;\n  background-color: #F5F5F5;\n}\n.asterisk[_ngcontent-%COMP%] {\n  padding-right: 2px;\n}\n.modal-header[_ngcontent-%COMP%] {\n  background-color: #ffffff;\n}\n.modal-header.modal-header-action[_ngcontent-%COMP%] {\n  padding-left: 25px;\n  padding-bottom: 4px;\n  margin-bottom: 0px;\n  display: flex;\n}\n.beds-section[_ngcontent-%COMP%] {\n  padding: 0px;\n  display: block;\n  position: relative;\n}\n.beds-data[_ngcontent-%COMP%] {\n  overflow-y: auto;\n  height: 65.5vh;\n}\n.modal-body[_ngcontent-%COMP%] {\n  padding: 0px;\n  background-color: #ffffff;\n  display: flex;\n}\n.modal-footer[_ngcontent-%COMP%] {\n  border: none;\n  border-top: 1px solid #D2D2D2;\n  padding: 15px;\n}\n.modal-footer[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]    + .btn[_ngcontent-%COMP%] {\n  margin-left: 10px;\n}\n.title[_ngcontent-%COMP%] {\n  font-size: 20px;\n  font-weight: 600;\n}\n.modal-footer[_ngcontent-%COMP%] {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  float: right;\n  padding: 15px;\n}\n.bed-list[_ngcontent-%COMP%] {\n  display: block;\n  background-color: #ffffff;\n  max-width: 1082px;\n}\n.bed-number[_ngcontent-%COMP%] {\n  display: inline-block;\n  padding-right: 8px;\n}\n.column[_ngcontent-%COMP%] {\n  margin: 0px;\n}\n.room-column[_ngcontent-%COMP%] {\n  width: 130px;\n  margin-right: 16px;\n}\n.bed-column[_ngcontent-%COMP%] {\n  width: 72px;\n  margin: 0 16px;\n}\n.location-column[_ngcontent-%COMP%] {\n  width: 213px;\n  margin: 0 16px;\n  min-height: 24px;\n}\n.room-type-column[_ngcontent-%COMP%] {\n  width: 222px;\n  margin: 0 16px;\n}\n.roommate-column[_ngcontent-%COMP%] {\n  width: 268px;\n  margin-left: 16px;\n  box-sizing: border-box;\n  align-items: center;\n}\n.roommate-column.roommates-no-locations[_ngcontent-%COMP%] {\n  width: 481px;\n  margin-left: 16px;\n}\n.roommate-info[_ngcontent-%COMP%] {\n  line-height: normal;\n  padding-bottom: 8px;\n}\n.list-header[_ngcontent-%COMP%] {\n  font-weight: bold;\n  display: flex;\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: 0;\n  color: #595959;\n  line-height: 56px;\n  vertical-align: middle;\n  border-top: 2px solid #D2D2D2;\n  border-bottom: 2px solid #D2D2D2;\n  padding-left: 16px;\n}\n.bed[_ngcontent-%COMP%] {\n  font-size: 12px;\n  line-height: 16px;\n  margin: 0px;\n}\n.close-modal[_ngcontent-%COMP%] {\n  position: relative;\n  width: 40px !important;\n  height: 40px !important;\n  top: -5px;\n  background-color: #ffffff;\n  border: none;\n  padding: 0;\n  border-radius: 50%;\n}\n.close-modal[_ngcontent-%COMP%]:hover, .close-modal[_ngcontent-%COMP%]:focus {\n  background-color: #EBF5F5;\n}\n.close-modal-icon[_ngcontent-%COMP%] {\n  width: 30px;\n  height: 30px;\n  background-color: #949494 !important;\n  font-family: 'Source Sans Pro' !important;\n}\n.effective-date-header[_ngcontent-%COMP%] {\n  padding-top: 30px;\n  padding-right: 30px;\n  padding-bottom: 40px;\n  vertical-align: middle;\n  width: 297px !important;\n}\n.effective-date-header[_ngcontent-%COMP%]   .effective-date-picker[_ngcontent-%COMP%] {\n  padding-top: 5px;\n}\n.left-panel-separator[_ngcontent-%COMP%] {\n  min-height: 32px !important;\n  margin: 0px 30px 0px 15px;\n  gap: 8px;\n  border-top: 1px solid #D2D2D2;\n}\n.left-panel-no-effective-date-top[_ngcontent-%COMP%] {\n  padding-top: 30px;\n}\n.filter-search-container[_ngcontent-%COMP%] {\n  min-height: 87px !important;\n  padding: 0px 30px 0px 15px;\n}\n.apply-filters[_ngcontent-%COMP%] {\n  padding: 8px 0px 20px 0px;\n}\n.apply-filters-btn[_ngcontent-%COMP%] {\n  background-color: #ffffff !important;\n}\n.apply-filters-btn[_ngcontent-%COMP%]:hover, .apply-filters-btn[_ngcontent-%COMP%]:focus {\n  text-decoration: none !important;\n  outline: none;\n  color: #414141;\n}\n.apply-filters-btn[_ngcontent-%COMP%]:disabled {\n  background-color: #F5F5F5 !important;\n  color: #757575;\n}\n.apply-filters-btn[_ngcontent-%COMP%]:disabled:hover, .apply-filters-btn[_ngcontent-%COMP%]:disabled:focus {\n  border-color: #AAAAAA;\n}\n.swap-container[_ngcontent-%COMP%] {\n  display: flex;\n}\n.disable-swap-checkbox[_ngcontent-%COMP%]    + div[_ngcontent-%COMP%]:before {\n  background-color: #F5F5F5 !important;\n}\n.swap[_ngcontent-%COMP%] {\n  display: flex;\n  padding-left: 8px;\n  background-color: #F5F5F5;\n  width: 40px !important;\n  height: 32px !important;\n}\n.swap-hover[_ngcontent-%COMP%]:hover, .swap-hover[_ngcontent-%COMP%]:focus {\n  background-color: #EBF5F5;\n  padding-left: 8px !important;\n  border-radius: 50%;\n}\n.swap[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%] {\n  z-index: 9999;\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n.swap[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:focus    + div[_ngcontent-%COMP%]:before, .swap[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:hover    + div[_ngcontent-%COMP%]:before {\n  border-color: #337ab7;\n  box-shadow: 2px;\n  background-color: #f2f2f2;\n}\nswap[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:active    + div[_ngcontent-%COMP%]:before {\n  transition-duration: 0s;\n}\n.swap[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]    + div[_ngcontent-%COMP%] {\n  position: relative;\n  padding-left: 2em;\n  vertical-align: middle;\n  user-select: none;\n  cursor: pointer;\n  margin: 0px;\n  font-size: 16px;\n}\n.swap[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]    + div[_ngcontent-%COMP%]:before {\n  box-sizing: content-box;\n  content: '';\n  color: #008381;\n  position: absolute;\n  top: 50%;\n  left: 10%;\n  width: 14px;\n  height: 14px;\n  margin-top: -9px;\n  border: 2px solid #949494;\n  border-radius: 2px;\n  text-align: center;\n  transition: all 0.4s ease;\n  background-color: #fff;\n}\n.swap[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]    + div[_ngcontent-%COMP%]:after {\n  box-sizing: content-box;\n  content: '';\n  position: absolute;\n  transform-origin: 50%;\n  transition: transform 200ms ease-out;\n  background-color: transparent;\n  top: 50%;\n  left: 4px;\n  width: 9px;\n  height: 4px;\n  margin-top: -5px;\n  border-style: solid;\n  border-color: #008381;\n  border-width: 0 0 2px 2px;\n  border-image: none;\n  transform: rotate(-45deg) scale(0);\n}\n.swap[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:checked    + div[_ngcontent-%COMP%]:after {\n  content: '';\n  border-color: #fff;\n  transform: rotate(-45deg) scale(1);\n  transition: transform 200ms ease-out;\n  left: 6px;\n}\n.swap[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:checked    + div[_ngcontent-%COMP%]:before {\n  animation: borderscale 200ms ease-in;\n  background-color: #008381;\n  border-color: #008381;\n}\n.checkbox[_ngcontent-%COMP%] {\n  position: relative;\n  width: 32px;\n  height: 32px;\n  padding-left: 0px !important;\n  border-radius: 50%;\n}\n.swap-text[_ngcontent-%COMP%] {\n  font-weight: 400;\n  padding-top: 8px;\n}\n.filter-label[_ngcontent-%COMP%] {\n  padding-bottom: 4px;\n}\n   .date-picker {\n  background-color: #ffffff !important;\n}\n   .mat-tooltip {\n  font-size: 14px;\n  color: #000000 !important;\n  background: #ffffff;\n  border: 1px solid #595959;\n  border-radius: 4px;\n  padding-bottom: 0px !important;\n  font-family: 'Source Sans Pro' !important;\n  max-width: unset !important;\n}\n.no-effective-date[_ngcontent-%COMP%] {\n  margin: auto;\n  width: 77.62%;\n  padding: 116px 0px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n.no-effective-date[_ngcontent-%COMP%]   .empty-icon[_ngcontent-%COMP%] {\n  width: 242px;\n  height: 227.47px;\n  flex-shrink: 0;\n  background-color: none;\n  background-image: url('images/emptyIllustration.svg');\n  background-repeat: no-repeat;\n}\n.no-effective-date[_ngcontent-%COMP%]   .no-results-text[_ngcontent-%COMP%] {\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 28px;\n  \n  letter-spacing: -0.2px;\n  padding-top: 30px;\n}\n.disabled[_ngcontent-%COMP%] {\n  background-color: #F5F5F5 !important;\n  border-color: #D2D2D2;\n  color: #757575;\n}\n.selected[_ngcontent-%COMP%] {\n  background-color: #EBF5F5 !important;\n  color: #414141 !important;\n}\n.padding-left[_ngcontent-%COMP%] {\n  padding-left: 8px;\n}\n.group-data[_ngcontent-%COMP%] {\n  border-bottom: 1px solid #D2D2D2;\n  display: flex;\n}\n.accommodation-row[_ngcontent-%COMP%] {\n  display: flex;\n  text-align: left;\n  cursor: default;\n  margin: 0px;\n  padding: 0px;\n  border: 0px;\n  padding-inline: 0px;\n  background-color: #ffffff;\n  padding: 8px 16px 8px 16px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  width: 100%;\n  color: #595959;\n}\n.accommodation-row[_ngcontent-%COMP%]:hover, .accommodation-row[_ngcontent-%COMP%]:focus {\n  background-color: #F5F5F5;\n  color: #414141;\n}\n.photo-wrapper[_ngcontent-%COMP%] {\n  display: inline-block;\n  width: 32px !important;\n  height: 32px;\n  margin-right: 8px;\n}\n.roommate-name-and-bed[_ngcontent-%COMP%] {\n  display: inline-block;\n  width: 228px !important;\n  vertical-align: middle;\n  line-height: normal;\n}\n.warning-icon[_ngcontent-%COMP%] {\n  width: 24px;\n  height: 24px;\n  font-size: 24px;\n  display: inline-block;\n  vertical-align: middle;\n  line-height: normal;\n}\n.warning-icon.occupied[_ngcontent-%COMP%] {\n  background-image: url(images/error-fill_D1.svg);\n}\n.warning-icon.out-of-service[_ngcontent-%COMP%] {\n  background-image: url(images/error-fill.svg);\n}\n.not-selectable[_ngcontent-%COMP%] {\n  text-decoration: line-through;\n}\n.sub-text[_ngcontent-%COMP%] {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  color: #595959;\n}\n.dropdown[_ngcontent-%COMP%] {\n  background-color: #ffffff;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AssignBedModalComponent, [{
        type: core_1.Component,
        args: [{
                templateUrl: './assign-bed-modal.component.html',
                styleUrls: ['./assign-bed-modal.component.less'],
                selector: 'assign-bed-modal'
            }]
    }], function () { return [{ type: i1.ResidentsService }, { type: i2.FormBuilder }, { type: i3.MatDialog }, { type: i4.DnaRSnackBarService }, { type: i5.FacilityService }]; }, { hideDialogEvent: [{
            type: core_1.Input
        }], saveEventCallBack: [{
            type: core_1.Input
        }], bedEffectiveDate: [{
            type: core_1.Input
        }], requestedAdmissionDate: [{
            type: core_1.Input
        }], residentId: [{
            type: core_1.Input
        }], expectedDepartureDate: [{
            type: core_1.Input
        }], filter: [{
            type: core_1.Input
        }], minDate: [{
            type: core_1.Input
        }], maxDate: [{
            type: core_1.Input
        }] }); })();
